import styles from './index.module.css';
const Spin = ({ className }) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${styles.spin} ${className}`}
    >
      <circle cx="18" cy="18" r="12" />
    </svg>
  );
};

export default Spin;
